import * as React from 'react'

import { type SortDirection, Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type GoalConfig from 'modules/goals/store/models/GoalConfig'

interface HeaderProps {
  goalConfig: GoalConfig
  onSort: (attribute: string, direction: SortDirection) => void
  attribute: string
  direction: SortDirection
}

type Title = {
  name: string
  colSpan: number
  attribute: string
}[]

const Header = ({ goalConfig, onSort, attribute, direction }: HeaderProps) => {
  const numericTitles: Title = [
    {
      name: i18n.t('surveys.goals.show.table.name'),
      colSpan: 3,
      attribute: 'user_name',
    },
    {
      name: i18n.t('surveys.goals.show.table.goal'),
      colSpan: 2,
      attribute: 'goal_value_in_cents',
    },
    {
      name: i18n.t('surveys.goals.show.table.current'),
      colSpan: 2,
      attribute: 'current_value_in_cents',
    },
    {
      name: i18n.t('surveys.goals.show.table.status'),
      colSpan: 3,
      attribute: 'progress_status',
    },
    {
      name: i18n.t('surveys.goals.show.table.percentage'),
      colSpan: 2,
      attribute: 'goal_progress',
    },
  ]

  const emptyTitles: Title = [
    {
      name: i18n.t('surveys.goals.show.table.name'),
      colSpan: 4,
      attribute: 'name',
    },
    {
      name: i18n.t('surveys.goals.show.table.progress'),
      colSpan: 7,
      attribute: 'progress',
    },
  ]

  const titles = goalConfig.isNumeric ? numericTitles : emptyTitles

  return (
    <Table.Head>
      <Table.Row>
        {titles.map((title) => (
          <Table.SortableHeadCell
            colSpan={title.colSpan}
            key={title.name}
            attribute={title.attribute}
            onSort={onSort}
            sortAttribute={attribute}
            sortDirection={direction}
          >
            {title.name}
          </Table.SortableHeadCell>
        ))}
        <Table.HeadCell colSpan={1} />
      </Table.Row>
    </Table.Head>
  )
}

export default observer(Header)
